import { render, staticRenderFns } from "./drawsizePro.vue?vue&type=template&id=482ee380&scoped=true&lang=pug"
import script from "./drawsizePro.vue?vue&type=script&lang=js"
export * from "./drawsizePro.vue?vue&type=script&lang=js"
import style0 from "./drawsizePro.vue?vue&type=style&index=0&id=482ee380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482ee380",
  null
  
)

export default component.exports